import { Formik } from 'formik';
import { Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import EmailHistoryTable from './EmailHistoryTable';
import SendDocumentEmailForm from './SendDocumentEmailForm';
import { useSendDocumentEmail, type OffSendDocumentEmailProps } from './model';

const OffSendDocumentEmail = (props: OffSendDocumentEmailProps) => {
    const { t } = useTranslation('Proposal');
    const { handleClose, handleSubmit, validate, isSending, history, historyError } = useSendDocumentEmail(props);

    return (
        <Offcanvas show={Boolean(props.target)} onHide={handleClose} placement="end" className="off-send-document-email">
            <Offcanvas.Header className="border-bottom" closeButton={!isSending}>
                <Offcanvas.Title>{t('edit.generate.sendDialog.title')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                <Formik
                    key={props.target ? `${props.target.source || 'object'}-${props.target.ID}` : 'closed'}
                    initialValues={{ email: props.defaultEmail, emailBody: '' }}
                    validate={validate}
                    onSubmit={handleSubmit}
                >
                    <SendDocumentEmailForm onClose={handleClose}>
                        <EmailHistoryTable rows={history} error={historyError} />
                    </SendDocumentEmailForm>
                </Formik>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffSendDocumentEmail;
